// @flow

import * as React from 'react';
import CodeBlock from 'app/components/docs/shared/code-block';
import Link from 'app/components/docs/shared/link';

import 'highlight.js/styles/atom-one-light.css';

type Props = {
  token?: string,
  className?: string,
  style?: Object
};

MacOSQuickStart.title = 'macOS';
MacOSQuickStart.emoji = ':finder:';

function MacOSQuickStart(props: Props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <p>If you have <Link href="http://brew.sh/">Homebrew</Link> installed you can use our <Link href="https://github.com/buildkite/homebrew-buildkite">Buildkite formula repository</Link> to install the agent:</p>
      <CodeBlock language="bash">
        brew tap buildkite/buildkite<br />
        brew install --token=<span className="hljs-string">&apos;{ props.token || 'INSERT-YOUR-AGENT-TOKEN-HERE' }&apos;</span> buildkite-agent<br />
      </CodeBlock>

      <p>If you don&apos;t use Homebrew you should follow the <Link href="/docs/agent/linux">Linux</Link> install instructions.</p>

      <p className="rounded bg-silver p2">
        See the <Link href="/docs/agent/osx">macOS agent docs</Link> for more details.
      </p>
    </div>
  );
}

export default MacOSQuickStart;
